// 订单充电过程
import React, { Component } from "react";
import "../../../assets/stylus/com/display/process.styl";
import PropsType from "prop-types";
import StubChargeCourse from "./stubChargeCourse";

class OrderStubCourse extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.state = {
      currentPhase: "stub",
    };
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    // this.query['orderId'] = '202004041900040516';
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["orderId"] = window.LayoutTab.tabParam.orderId;
    }
  }

  componentDidMount() {
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["orderId"] = window.LayoutTab.tabParam.orderId;
    }
  }

  handleModuleTypeChange = (e) => {
    this.setState({
      currentPhase: e.target.value,
    });
  };

  render() {
    const Content = (
      <div className='sc-page-content'>
        <div>
          <StubChargeCourse params={this.query}></StubChargeCourse>
        </div>
      </div>
    );
    return Content;
  }
}

export default OrderStubCourse;

OrderStubCourse.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/orderStubCourse.js